<h3 mat-dialog-title>{{title}}</h3>
<div class="mat-dialog-content">
    <div [innerHTML]="message"></div>
</div>
<div mat-dialog-actions class="pull-right">
    <button class="btn btn-primary" (click)="onConfirm()">{{confirmText}}</button>
</div>
